// extracted by mini-css-extract-plugin
module.exports = {"gap":"RegularPageTemplate-styles_gap__1b9BG","main":"RegularPageTemplate-styles_main__1ZiZ1"};